import { render } from "./HistorialPagosHotel.vue?vue&type=template&id=96633d04&scoped=true"
import script from "./HistorialPagosHotel.vue?vue&type=script&lang=js"
export * from "./HistorialPagosHotel.vue?vue&type=script&lang=js"

import "./HistorialPagosHotel.vue?vue&type=style&index=0&id=96633d04&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96633d04"]])

export default __exports__